export function fixMalformedHtml(htmlContent: string) {
    if (!htmlContent || htmlContent === "") {
        return htmlContent;
    }

    // Fix malformed HTML entities like <lt>, <lt/>, <gt>, and <gt/> back to proper < and >
    return htmlContent.replace(/<lt\/?>/g, "<").replace(/<gt\/?>/g, ">");
}

function extractBody(htmlContent: string) {
    if (!htmlContent || htmlContent === "") {
        return htmlContent;
    }

    // First try to extract body content
    const bodyStart = htmlContent.indexOf("<body>");
    const bodyEnd = htmlContent.indexOf("</body>");
    if (bodyStart >= 0 && bodyEnd >= 0) {
        return htmlContent.substring(bodyStart + 6, bodyEnd);
    }

    // If no body tags, try to strip html and head tags
    const htmlStart = htmlContent.indexOf("<html");
    const htmlEnd = htmlContent.lastIndexOf("</html>");
    if (htmlStart >= 0 && htmlEnd >= 0) {
        // Get content between <html...> and </html>
        const afterHtmlTag = htmlContent.indexOf(">", htmlStart);
        let content = htmlContent.substring(afterHtmlTag + 1, htmlEnd).trim();

        // Also strip head tags if present
        const headStart = content.indexOf("<head");
        const headEnd = content.indexOf("</head>");
        if (headStart >= 0 && headEnd >= 0) {
            // Remove everything from <head to </head>
            content = content.substring(0, headStart) + content.substring(headEnd + 7);
            content = content.trim();
        }

        return content;
    }

    return htmlContent;
}

function sanitizeHtml(htmlContent: string): string {
    if (!htmlContent || htmlContent.trim() === "") {
        return htmlContent;
    }

    // Check if we're in a browser environment (not SSR)
    if (typeof window === "undefined" || !window.DOMParser) {
        // During SSR, return the content as-is since we can't use DOMParser
        return htmlContent;
    }

    try {
        // Create a temporary container to parse HTML without full document structure
        const template = document.createElement("template");
        template.innerHTML = htmlContent.trim();

        // Remove problematic elements
        const problematicElements = template.content.querySelectorAll("script, iframe, object, embed");
        problematicElements.forEach(el => el.remove());

        // Return sanitized HTML
        return template.innerHTML;
    } catch (error) {
        // eslint-disable-next-line no-console
        console.error("Error sanitizing HTML, returning original content:", error);
        // On error, strip script tags at minimum for security
        return htmlContent.replace(/<script\b[^<]*(?:(?!<\/script>)<[^<]*)*<\/script>/gi, "");
    }
}

export default function transformContentHtmlCustom(htmlContent: string) {
    if (!htmlContent) {
        return htmlContent;
    }

    const fixed = fixMalformedHtml(htmlContent);

    const extracted = extractBody(fixed);

    const sanitized = sanitizeHtml(extracted);

    return sanitized;
}
